import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { DragDropDirective } from '../../directive/drag-drop-directive';
import { DocumentService } from 'src/app/services/document.service';
import { filter, interval, Observable, Subscription } from 'rxjs';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { EDocumentType } from './document-type';

@Component({
    selector: 'app-multiple-file-upload-box',
    templateUrl: 'multiple-file-upload-box.html',
    styleUrl: './multiple-file-upload-box.scss',
    standalone: true,
    imports: [MatDialogModule, DragDropDirective, MatIconModule, MatChipsModule, MatButtonModule, PreventDoubleClickDirective, MatChipsModule, NgCircleProgressModule]
})
export class MultipleFileUploadBoxDialog {

    Files: File[] = [];
    PercentDone = 0;

    private Sub?: Subscription;

    private type: EDocumentType;
    private code: string = '';

    public get CanAddDocument() {
        return this.Files.length === 1;
    }

    constructor(
        private documentService: DocumentService,
        public dialogRef: MatDialogRef<MultipleFileUploadBoxDialog>,

        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.type = data.type;
        if (data.code) {
            this.code = data.code;
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onFileChange(event: any) {

        const files = event.srcElement.files as File[];
        if (files) {
            this.Files.push(...Array.from<File>(files));
        }
        this.Files = _.uniqBy(this.Files, 'name');
    }

    onFileFromDragNDrop(event: any) {
        let files = event instanceof FileList ? event : event.files;

        for (let index = 0; index < files.length; index++) {
            const element = files[index];
            this.Files.push(element);
        }
        this.Files = _.uniqBy(this.Files, 'name');
    }

    remove(file: File): void {
        const index = this.Files.indexOf(file);

        if (index >= 0) {
            this.Files.splice(index, 1);
        }
    }

    uploadDocument() {
        switch (this.type) {
            case EDocumentType.Plan:
                this.addQualifPlanDocument()
                break;
            case EDocumentType.Result:
                this.addResultDocument();
                break;
            case EDocumentType.OverrideReport:
                this.overrideReportDocument();
                break;
        }
    }

    addResultDocument() {

        this.documentService.addMesureTerrainDocument(this.Files[0])
            .pipe(filter((e: any) => e instanceof HttpResponse || e.type === HttpEventType.UploadProgress))
            .subscribe(
                event => {
                    if (event.type === HttpEventType.UploadProgress) {
                        this.PercentDone = Math.round(80 * event.loaded / event.total);
                        if (this.PercentDone >= 80) {
                            this.Sub = interval(100).pipe().subscribe(() => {
                                if (this.PercentDone < 99) {

                                    this.PercentDone = this.PercentDone + 1;
                                }
                            });
                        }
                    } else if (event instanceof HttpResponse) {
                        this.Sub?.unsubscribe();
                        this.PercentDone = 100;
                        setTimeout(() => {
                            this.PercentDone = 0;
                            this.dialogRef.close(event.body); // EDM NAME
                        }, 500);
                    }
                },
                (err) => {
                    this.Sub?.unsubscribe();
                    this.dialogRef.close();
                    console.log('Upload Error:', err);
                }, () => {
                }
            );
    }

    addQualifPlanDocument() {

        this.documentService.addPlanToQualifDocument(this.Files[0], this.code)
            .pipe(filter((e: any) => e instanceof HttpResponse || e.type === HttpEventType.UploadProgress))
            .subscribe(
                event => {
                    if (event.type === HttpEventType.UploadProgress) {
                        this.PercentDone = Math.round(80 * event.loaded / event.total);
                        if (this.PercentDone >= 80) {
                            this.Sub = interval(100).pipe().subscribe(() => {
                                if (this.PercentDone < 99) {

                                    this.PercentDone = this.PercentDone + 1;
                                }
                            });
                        }
                    } else if (event instanceof HttpResponse) {
                        this.Sub?.unsubscribe();
                        this.PercentDone = 100;
                        setTimeout(() => {
                            this.PercentDone = 0;
                            this.dialogRef.close(event.body); // EDM NAME
                        }, 500);
                    }
                },
                (err) => {
                    this.Sub?.unsubscribe();
                    this.dialogRef.close();
                    console.log('Upload Error:', err);
                }, () => {
                }
            );
    }

    overrideReportDocument() {

        this.documentService.overrideReport(this.Files[0], this.code)
            .pipe(filter((e: any) => e instanceof HttpResponse || e.type === HttpEventType.UploadProgress))
            .subscribe(
                event => {
                    if (event.type === HttpEventType.UploadProgress) {
                        this.PercentDone = Math.round(80 * event.loaded / event.total);
                        if (this.PercentDone >= 80) {
                            this.Sub = interval(100).pipe().subscribe(() => {
                                if (this.PercentDone < 99) {

                                    this.PercentDone = this.PercentDone + 1;
                                }
                            });
                        }
                    } else if (event instanceof HttpResponse) {
                        this.Sub?.unsubscribe();
                        this.PercentDone = 100;
                        setTimeout(() => {
                            this.PercentDone = 0;
                            this.dialogRef.close(event.body); // EDM NAME
                        }, 500);
                    }
                },
                (err) => {
                    this.Sub?.unsubscribe();
                    this.dialogRef.close();
                    console.log('Upload Error:', err);
                }, () => {
                }
            );
    }
}
